export const OPEN_TO_KEYS = ["hiring", "job_search", "mentoring", "speaking"] as const;

export type OpenToKey = (typeof OPEN_TO_KEYS)[number];

export type OpenToFlags = {
  open_to_hiring?: boolean;
  open_to_job_search?: boolean;
  open_to_mentoring?: boolean;
  open_to_speaking?: boolean;
};

export const OPEN_TO_LABELS: Record<OpenToKey, string> = {
  hiring: "Open to hiring",
  job_search: "Open to roles",
  mentoring: "Open to mentoring",
  speaking: "Open to speaking",
};

export const OPEN_TO_FIELD: Record<OpenToKey, keyof OpenToFlags> = {
  hiring: "open_to_hiring",
  job_search: "open_to_job_search",
  mentoring: "open_to_mentoring",
  speaking: "open_to_speaking",
};

export function activeOpenToKeys(flags: OpenToFlags | null | undefined): OpenToKey[] {
  if (!flags) return [];
  return OPEN_TO_KEYS.filter((key) => !!flags[OPEN_TO_FIELD[key]]);
}
